import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Star, ArrowUpRight, MapPin, Phone, Mail, Clock } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
import { SERVICES, AREAS } from "../mock";

export default function Footer() {
  const s = useSettings();

  return (
    <footer className="bg-ink text-white relative overflow-hidden">
      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-8 pt-24 pb-10">
        {/* Giant wordmark */}
        <div className="mb-20 select-none">
          <div className="font-display-tight text-white text-[18vw] leading-[0.85] tracking-[-0.04em] whitespace-nowrap" style={{ opacity: 0.95 }}>
            RS<span className="text-amber italic">.</span>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 mb-20">
          {/* Contact */}
          <div className="lg:col-span-5">
            <div className="text-eyebrow text-amber mb-5">— The Studio</div>
            <h3 className="font-display text-4xl md:text-5xl text-white leading-[1.05] mb-8 max-w-md">
              Bespoke construction.<br />Built across UK.
            </h3>
            <div className="space-y-4 text-[15px] text-white/85 leading-relaxed">
              <div className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-1 text-amber shrink-0" /><span>{s?.address_line1}, {s?.address_line2}, {s?.address_line3}, {s?.address_city}</span></div>
              <div className="flex items-center gap-3"><Phone className="w-4 h-4 text-amber shrink-0" /><a href={`tel:${s?.phone}`} className="hover:text-amber">{s?.phone}</a></div>
              <div className="flex items-center gap-3"><Mail className="w-4 h-4 text-amber shrink-0" /><a href={`mailto:${s?.email}`} className="hover:text-amber">{s?.email}</a></div>
              <div className="flex items-start gap-3"><Clock className="w-4 h-4 mt-1 text-amber shrink-0" /><span>{s?.hours_weekdays} · {s?.hours_saturday}</span></div>
            </div>
          </div>

          {/* Nav */}
          <div className="lg:col-span-2">
            <div className="text-eyebrow text-white/60 mb-5">Navigate</div>
            <ul className="space-y-3 text-[15px]">
{[["/","Home"],["/about","About"],["/services","Services"],["/projects","Projects"],["/contact","Contact"],["/admin","Admin"]].map(([to, l]) => (                <li key={to}><Link to={to} className="link-line text-white/85 hover:text-white transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="lg:col-span-3">
            <div className="text-eyebrow text-white/60 mb-5">Disciplines</div>
            <ul className="space-y-3 text-[15px]">
              {SERVICES.slice(0, 7).map((sv) => (
                <li key={sv.slug}>
                  <Link to={`/services/${sv.slug}`} className="link-line text-white/85 hover:text-white transition-colors">{sv.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Rating & Socials */}
          <div className="lg:col-span-2">
            <div className="text-eyebrow text-white/60 mb-5">Reputation</div>
            <div className="border border-white/20 p-5 mb-6">
              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, k) => <Star key={k} className="w-3.5 h-3.5 text-amber" style={{ fill: "#b8864a" }} />)}
              </div>
              <div className="font-display text-4xl text-white leading-none mb-1">4.9 <span className="text-amber">/</span> 5</div>
              <div className="text-[11px] tracking-[0.2em] uppercase text-white/65">340+ Google reviews</div>
            </div>
            <div className="flex gap-2">
  <a
    href={s?.instagram || "#"}
    target="_blank"
    rel="noreferrer"
    className="h-10 w-10 border border-white/25 flex items-center justify-center text-white/85 hover:bg-amber hover:text-ink hover:border-amber transition-colors"
  >
    <Instagram className="w-4 h-4" />
  </a>

  <a
    href={s?.facebook || "#"}
    target="_blank"
    rel="noreferrer"
    className="h-10 w-10 border border-white/25 flex items-center justify-center text-white/85 hover:bg-amber hover:text-ink hover:border-amber transition-colors"
  >
    <Facebook className="w-4 h-4" />
  </a>
              <Link to="/contact" className="h-10 flex items-center gap-2 px-4 border border-white/25 text-white/85 hover:bg-amber hover:text-ink hover:border-amber transition-colors text-[11px] tracking-[0.22em] uppercase">
                Enquire <ArrowUpRight className="w-3.5 h-3.5" />
              </Link>
            </div>
          </div>
        </div>

        {/* Areas */}
        <div className="border-t border-white/15 pt-10 mb-10">
          <div className="text-eyebrow text-white/60 mb-4">Areas Covered</div>
          <div className="flex flex-wrap gap-x-5 gap-y-2 text-[13px] text-white/80">
            {AREAS.map((a) => <span key={a}>{a}</span>)}
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[11px] tracking-[0.15em] uppercase text-white/55">
          <div>© {new Date().getFullYear()} RS Construction (HI) Ltd · Company No. 1514 4432</div>
          <div className="flex gap-6">
            <Link to="/" className="hover:text-white transition-colors">Privacy</Link>
            <Link to="/" className="hover:text-white transition-colors">Terms</Link>
            <Link to="/admin" className="hover:text-amber transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
